import { getApiUrl } from '../_helpers';

export const fileService = {
  upload
};

function upload(data) {
  var url = getApiUrl() + 'site/file/upload';

  return new Promise((resolve, reject) => {
    fetch(url, {
      method: 'POST',
      body: data,
      credentials: 'include'
    })
      .then(response => {
        if (response.status === 200) {
//          resolve(response.json().then(data => data));
        }
//        else if (response.status === 409) {
//          reject("There was an error saving the event.");
//        }
        else {
          reject(response.statusText);
        }
      })
      .catch(response => {
        reject(response.statusText);
      })
  });
}
